import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-electronic-signature-radio-button',
  templateUrl: './electronic-signature-radio-button.component.html',
  styleUrls: ['./electronic-signature-radio-button.component.scss'],
})
export class ElectronicSignatureRadioButtonComponent implements OnInit, OnDestroy {
  public signature: string[] = [];
  public selected: string = '';
  @Input() public control: UntypedFormControl = new UntypedFormControl();
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor() {
    this.signature = [
      'Signed',
      'Not Signed',
      'All',
    ];
  }

  public ngOnInit(): void {
    this.selected = this.signature[2];
    this.valueChanged();

    this.control.valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => {
        if (values === undefined || values === null) {
          this.selected = this.signature[2];
        }
      });

  }

  public valueChanged() {
    this.control.setValue(this.selected);
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
